import { render, staticRenderFns } from "./MallPayResultPage.vue?vue&type=template&id=d91bf918&scoped=true"
import script from "./MallPayResultPage.vue?vue&type=script&lang=js"
export * from "./MallPayResultPage.vue?vue&type=script&lang=js"
import style0 from "./MallPayResultPage.vue?vue&type=style&index=0&id=d91bf918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91bf918",
  null
  
)

export default component.exports